
import { Component, PropSync, Vue } from 'nuxt-property-decorator'
import { WithFetch } from '~/core/vue.types'
import { $api } from '~/plugins/axios'
import { B2bFormRequestPayload } from '~/services/common.service'
import { AlButton } from '~/components/ui'

@Component({
  components: {
    AlButton,
  },
})
export default class B2bForm extends Vue implements WithFetch {
  @PropSync('isLoading', { required: true, default: false, type: Boolean })
  loading!: boolean

  private form: B2bFormRequestPayload = {
    company_name: '',
    contact_person: '',
    phone_number: '',
    email: '',
    number_of_employees: '',
    purpose: '',
    comment: '',
    token: '',
  }

  private employeers = []
  private purposes = []

  async fetch () {
    try {
      const response = await $api.CommonService.getB2bFormFields()
      this.employeers = response.number_of_employees
      this.form.number_of_employees = this.employeers[0]
      this.purposes = response.purpose
      this.form.purpose = this.purposes[0]
    } catch (e) {
      this.$nuxt.error({ statusCode: 500 })
    }
  }

  async mounted () {
    try {
      await this.$recaptcha.init()
    } catch (e) {
      console.error(e)
    }
  }

  beforeDestroy () {
    this.$recaptcha.destroy()
  }

  async submit () {
    if (!(await this.$validator.validate())) {
      return
    }

    this.loading = true

    let token

    try {
      token = await this.$recaptcha.execute('b2b')
    } catch (error) {
      this.loading = false
      throw new Error('captcha b2b error:' + error)
    }

    try {
      await $api.CommonService.submitB2bForm({ ...this.form, token })
      this.$analytics.GTM.trackRaw({
        eventCategory: 'b2b-form',
        eventAction: 'form-submission',
        eventLabel: `${this.form.company_name}|${this.form.number_of_employees}`,
      })
      this.$emit('submitted')
      this.reset()
    } finally {
      this.loading = false
    }
  }

  reset () {
    this.form = {
      company_name: '',
      contact_person: '',
      phone_number: '',
      email: '',
      number_of_employees: this.employeers[0],
      purpose: this.purposes[0],
      comment: '',
      token: '',
    }
    this.$validator.reset()
  }
}
